export default __webpack_public_path__ + "static/media/mat-man-wdt.7ee22833.png";